export const OPEN_PRODUCT = 'OPEN_PRODUCT';
export const CLOSE_PRODUCT = 'CLOSE_PRODUCT';
export const CLOSE_ALL_EXCEPT = 'CLOSE_ALL_EXCEPT';

export type OpenProductsState = {
  invoiceId: number;
  productId: number;
};
